import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

export default ({ color = defaultIconColor, ...props }: Omit<SVGComponentPropsType, 'size'>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" {...props}>
    <g transform="translate(-61 -4)" fill="none" fillRule="evenodd">
      <g transform="translate(62 5)">
        <path
          d="M7.642 8.632v-.293c0-.195.041-.353.124-.474.083-.12.28-.296.593-.527.456-.326.765-.619.928-.879.163-.26.244-.57.244-.928 0-.537-.198-.967-.593-1.289-.396-.322-.929-.483-1.6-.483-.813 0-1.583.203-2.309.61l.533 1.07c.625-.32 1.181-.479 1.67-.479.28 0 .497.055.654.166.156.11.234.272.234.483 0 .19-.054.36-.163.513-.11.153-.335.352-.677.596-.355.26-.599.506-.732.737-.134.231-.2.503-.2.816v.36h1.294Zm-.591 2.5c.267 0 .475-.074.625-.222.15-.148.224-.351.224-.608 0-.267-.074-.472-.222-.615-.148-.144-.357-.215-.627-.215-.28 0-.493.07-.64.21-.146.14-.22.346-.22.62 0 .263.075.468.225.613.15.144.361.217.635.217Z"
          fill={color}
          fillRule="nonzero"
        />
        <circle stroke={color} strokeWidth="2" cx="7" cy="7" r="7" />
      </g>
    </g>
  </svg>
);
